import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TimerIcon from "@mui/icons-material/Timer";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const BottomNav = ({ role, currentTab, onClick, onMenuToggle, sidebarOpen }) => {
  // Determine active state for tabs based on current screen path
  const getTabClass = (tabNames) => {
    return tabNames.includes(currentTab) ? "bottom-nav-item active" : "bottom-nav-item";
  };

  const isAdmin = role === "admin";

  const handleTabClick = (tabName) => {
    onClick(tabName);
  };

  return (
    <div className="bottom-nav">
      {/* 1. Dashboard Tab */}
      <button 
        className={getTabClass(["dashboard"])} 
        onClick={() => handleTabClick("dashboard")}
      >
        <DashboardIcon />
        <span>Dashboard</span>
      </button>

      {/* 2. Attendance Tab */}
      {isAdmin ? (
        <button 
          className={getTabClass(["Attendence", "Attendence regularization", "In out activities", "Daily attendence", "Manage shift", "All Attendence"])} 
          onClick={() => handleTabClick("Attendence")}
        >
          <AccessTimeIcon />
          <span>Attendance</span>
        </button>
      ) : (
        <button 
          className={getTabClass(["PunchTime"])} 
          onClick={() => handleTabClick("PunchTime")}
        >
          <TimerIcon />
          <span>Punch</span>
        </button>
      )}

      {/* 3. Leave Tab */}
      {isAdmin ? (
        <button 
          className={getTabClass(["Leave", "Approvals", "Leave balance", "Leave Policy", "Approved Leaves"])} 
          onClick={() => handleTabClick("Leave")}
        >
          <EventAvailableIcon />
          <span>Leave</span>
        </button>
      ) : (
        <button 
          className={getTabClass(["Apply leave"])} 
          onClick={() => handleTabClick("Apply leave")}
        >
          <FlightTakeoffIcon />
          <span>Leave</span>
        </button>
      )}

      {/* 4. Payroll Tab */}
      {isAdmin ? (
        <button 
          className={getTabClass(["Payroll", "Salary register", "Salary process", "Bank transfer", "BankDetail", "Salary paySilp", "Final settlement", "Reimbursement", "All payroll"])} 
          onClick={() => handleTabClick("Payroll")}
        >
          <CurrencyRupeeIcon />
          <span>Payroll</span>
        </button>
      ) : (
        <button 
          className={getTabClass(["salarygenerate", "EmpSalarySlip"])} 
          onClick={() => handleTabClick("salarygenerate")}
        >
          <ReceiptIcon />
          <span>Salary</span>
        </button>
      )}

      {/* 5. Menu / More Tab (Toggles Sidebar drawer) */}
      <button 
        className={`bottom-nav-item ${sidebarOpen ? "active" : ""}`} 
        onClick={onMenuToggle}
      >
        {sidebarOpen ? <CloseIcon /> : <MenuIcon />}
        <span>Menu</span>
      </button>
    </div>
  );
};

export default BottomNav;
